export default __webpack_public_path__ + "static/media/about-left.9b3f6c12.jpg";